import { Component, effect, inject, type OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import type { EventType } from '../../../server/models/event-item.model';
import { AuthService } from '../../core/auth/services/auth.service';
import type { EventItem } from '../../core/models/middleware/event-item.model';
import type { UserItem } from '../../core/models/middleware/user-item.model';
import type { QuestionItemModel } from '../../core/models/question-item.model';
import { EventService } from '../../core/services/event.service';
import { QuestionService } from '../../core/services/question.service';
import { AccordionComponent } from '../../shared/components/accordion/accordion.component';
import { SharedCardComponent } from '../../shared/components/shared-card/shared-card.component';
import { EnforceNewLinePipe } from '../../shared/pipes/enforce-new-line.pipe';

@Component({
  selector: 'app-info',
  imports: [AccordionComponent, SharedCardComponent, EnforceNewLinePipe],
  templateUrl: './questions.component.html',
})
export class QuestionsComponent implements OnInit {
  user?: UserItem;
  questionItems = signal<QuestionItemModel[]>([]);
  private route = inject(ActivatedRoute);
  private questionService = inject(QuestionService);
  private authService = inject(AuthService);
  private eventService = inject(EventService);

  constructor() {
    effect(() => {
      if (this.eventService.getCurrentEvent()) {
        this.questionService
          .getQuestionItems((this.eventService.getCurrentEvent() as EventItem<EventType>).documentId)
          .subscribe({
            next: (data) => {
              return this.questionItems.set(
                // Important questions are first
                data.sort((a, b) => {
                  if (a.important === b.important) return 0;
                  return a.important ? -1 : 1;
                })
              );
            },
            error: (error) => {
              console.error('Error fetching question items:', error);
            },
          });
      }
    });
  }

  ngOnInit(): void {
    this.user = this.authService.currentUser() || undefined;
    const eventDocumentId = this.route.snapshot.params.eventDocumentId as string;
    const eventType = this.route.snapshot.params.eventType as EventType;
    if (!this.eventService.getCurrentEvent() || this.eventService.getCurrentEvent()?.documentId !== eventDocumentId) {
      this.eventService.getEvent(eventDocumentId, eventType).subscribe((value) => {
        this.eventService.setCurrentEvent(value);
      });
    }
  }
}
